import React from "react";

function label(value) {
  return String(value || "unresolved")
    .replace(/_/g, " ")
    .toLowerCase();
}

export default function ResultantComparison({
  leftOrientation,
  rightOrientation,
}) {
  const left = label(leftOrientation);
  const right = label(rightOrientation);
  const stable = left === right;

  return (
    <section className="rr-resultant-compare">
      <div className="rr-resultant-head">
        <div>
          <span className="v25a-eyebrow">RESULTANT COMPARISON</span>
          <h4>{stable ? "Orientation stable · topology changed" : "Resultant differs"}</h4>
        </div>
        <span className={stable ? "stable" : "different"}>
          {left.toUpperCase()} → {right.toUpperCase()}
        </span>
      </div>

      <div className="rr-resultant-strip">
        <div className={left}>
          <i />
          <b>Configuration A · {left}</b>
        </div>

        <span className="rr-resultant-axis">
          <i />
          <b>Δ</b>
          <i />
        </span>

        <div className={right}>
          <i />
          <b>Configuration B · {right}</b>
        </div>
      </div>

      <p>
        {stable
          ? "Both configurations produce the same resultant orientation. What differs is the research topology around the stable capability."
          : "The two configurations produce different resultant orientations. This is still a comparison, not a before/after transition."}
      </p>
    </section>
  );
}
